import { prop } from '@ipfabric/utils/fp/prop';
import classNames from 'classnames';
import { useGlobalStateContextSelectors } from 'components/GlobalState/GlobalStateModel';
import { setMinimisedMenu } from 'components/GlobalState/commands/setMinimisedMenu';
import type { FC } from 'react';

export const SidebarToggle: FC = () => {
  const globalStateCtxProps = useGlobalStateContextSelectors({
    dispatch: prop('dispatch'),
    minimisedMenu: prop('minimisedMenu'),
  });

  const onButtonClick = () => {
    globalStateCtxProps.dispatch(setMinimisedMenu, {
      value: !globalStateCtxProps.minimisedMenu,
    });
  };

  return (
    <button
      className='sidebar__sidebar-toggle'
      onClick={onButtonClick}
      type='button'
    >
      <i
        className={classNames(
          'fa',
          globalStateCtxProps.minimisedMenu
            ? 'fa-chevron-right'
            : 'fa-chevron-left',
        )}
      />
    </button>
  );
};
